module.exports = __webpack_public_path__ + "static/img/platform.ac71fce.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/platform.svg
// module id = oBXM
// module chunks = 4